export const tmaisUsersDefaultColumns = [
  { label: 'Nome', value: 'full_name' },
  { label: 'Ações', value: 'action', className: 'w-11' },
];
